import { connect } from "react-redux";
import { withRouter } from "react-router";
import WIAuthorPDF from './WIAuthor/WIAuthorPDF'
import {  saveWorkInstruction, editWorkInstruction} from '../../../../redux/actions/wi_actions'


const mapStateToProps = (state, ownProps) => {
    // Access user data assuming state.users is an object keyed by user ID
    // Add checks for safety
    const currentUser = state.users && state.session?.user?._id
        ? state.users[state.session.user._id] || null // Lookup by ID, default null if not found
        : null; // Default null if users or session info is missing

    return ({
        workInstruction: state.author,
        workInstructions: state.work_instructions.all,
        isLiteView: ownProps.isLiteView,
        user: currentUser // Pass the found user object or null
    });
}

const mapDispatchToProps = (dispatch, ownProps) => {
    let wip_ID = ""

    if (typeof ownProps.wip_ID != "undefined" && ownProps.wip_ID !== null){
        wip_ID = ownProps.wip_ID
    }
    else{
        wip_ID = ownProps.location.pathname.split('/').pop()
    }
    return ({
        updateWorkInstruction: updatedWorkInstruction => dispatch(saveWorkInstruction(updatedWorkInstruction)),
        editWorkInstruction: (() => dispatch(editWorkInstruction(wip_ID))),
        //addTab: (()=>dispatch(ownProps.addTab(title,wip_ID)))
    });
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WIAuthorPDF));
